import { render } from "./TopicsListView.vue?vue&type=template&id=30570421&scoped=true"
import script from "./TopicsListView.vue?vue&type=script&lang=js"
export * from "./TopicsListView.vue?vue&type=script&lang=js"

import "./TopicsListView.vue?vue&type=style&index=0&id=30570421&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30570421"]])

export default __exports__